const CONVERTABLE_QUOTES = [
  'ETH-0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // WETH
  'POLYGON-0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', // WMATIC
  'ETH-0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', // WBTC
  'BSC-0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', // WBNB
  'BSC-0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82', // Cake
  'ELROND-WEGLD-bd4d79', // WEGLD
  'AVAX-0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7', // WAVAX
  'FTM-0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83', // WFTM
];
const CONV_SYMBOL = 'USD@';

const pairConvertable = (chain: string, quoteAddress: string): boolean => {

  const key = `${chain}-${quoteAddress}`;
  return CONVERTABLE_QUOTES.includes(key);
};

const convertSymbol = (symbol: string): string => {
  const [exchnage, pair] = symbol.split(':');
  const [base, quote] = pair.split('/');
  return `${exchnage}:${base}/${CONV_SYMBOL}${quote}`;
};

const getConvSymbol = (sym: string) => sym.split(CONV_SYMBOL)[1];

const filterSymbolFromConv = (sym: string) => sym.split(CONV_SYMBOL).join('');

export {
  CONVERTABLE_QUOTES,
  CONV_SYMBOL,
  convertSymbol,
  filterSymbolFromConv,
  getConvSymbol,
  pairConvertable,
};
